import React, { useEffect, useCallback, useState } from 'react';
import TableComponent from '../../common/table/Table';
import { Box, IconButton, Grid } from '@mui/material';
import { DownloadingIcon } from '../../../shared/components/icon';
import AxiosInstance from '../../../server/AxioInstance';
import { useDialog, useSnackbar } from '../../../shared/context';
import ViewDocumentDialog from '../../Dialog/ViewDocumentDialog';
import SelectAutoComplete from '../../common/autoComplete/SelectAutoComplete';

import { useDownload } from '../../../shared/context';

const columns = [
    // { id: "document_type", label: "Tipo do documento", align:'center' },
    { id: "title", label: "Título", align: 'left' },
    { id: "sector", label: "Setor", align: 'center' },
    { id: "view", label: "Visualizar", align: 'center' },
    { id: "document_review", label: "Versão", align: 'center' },
    { id: "dt_review", label: "Data da revisão", align: 'center' },
    { id: "download", label: "download", align: 'center' },
]

const BodyViewDocument = () => {
    const { handleDownload } = useDownload();
    const { isDialogOpen, openDialog, closeDialog, dialogData } = useDialog('viewDocumentDialog');
    const { showSnackbar } = useSnackbar();
    const [rows, setRows] = useState([]);
    const [getOptionsSector, setOptionsSector] = useState([]);
    const [getOptionsSubSector, setOptionsSubSector] = useState([]);
    const [getFormData, setFormData] = useState({
        sector: [],
        subSector: []
    });

    // ------------ function dialog ------------ //
    const handleOpenDialog = (item, index) => {
        openDialog({ item, index });
    };

    const handleCloseDialog = () => {
        closeDialog();
    };

    const handleCancelAction = () => {
        handleCloseDialog();
    };
    // ------------ function dialog ------------ //

    const handleChangeSector = (e, value) => {
        setFormData((prevData) => ({ ...prevData, sector: value, subSector: [] }));
        setRows([]);
        getSubSector(value);
    }

    const handleChangeSubSector = (e, value) => {
        setFormData((prevData) => ({ ...prevData, subSector: value }));
        getDataTable(value);
    }

    const handleViewDocument = async (item, index) => {
        handleOpenDialog(item, index);
    }

    const renderDownloadIcon = (item, index) => {
        return (
            <IconButton
                aria-label="download"
                onClick={() => handleDownload(item, index)}
                disabled={localStorage.getItem('@gedy:group') === '2'}
            >
                <DownloadingIcon fontSize="large" color={localStorage.getItem('@gedy:group') === '2' ? '#d0d0d0' : 'success'} />
            </IconButton>
        )
    };

    const extractRevision = (originalname) => {
        // Divide o nome do arquivo em partes com base em um espaço
        const parts = originalname.split(' ');
        // Procura por uma parte que contenha um "R" seguido de dois dígitos
        const revisionPart = parts.find(part => /R\d{2}/.test(part));

        if (revisionPart) {
            return revisionPart.slice(-3);
        }

        return 'R00';
    };

    const getDataTable = useCallback(async (value) => {
        const data = {
            ...value,
            user_login: localStorage.getItem('@gedy:user'),
            id_group: localStorage.getItem('@gedy:group'),
        }
        try {
            const result = await AxiosInstance.post('/manipulate-documents/view', data);
            const temp = result.data.rows ? result?.data?.rows?.map((item, index) => ({
                ...item,
                revision: extractRevision(item.originalname),
                view: (
                    <>
                        <IconButton
                            aria-label="view"
                            onClick={() => handleViewDocument(item, index)}
                        >
                            <DownloadingIcon fontSize="large" color="primary" />
                        </IconButton>
                    </>
                ),
                download: renderDownloadIcon(
                    {
                        filename: item.filename,
                        type: item.document_type,
                        originalname: item.originalname
                    }),
            })) : [];
            setRows(temp);
        } catch (error) {
            showSnackbar({
                vertical: 'top',
                horizontal: 'right',
                message: error.message,
                variant: 'error',
            });
        }
        // eslint-disable-next-line
    }, []);

    const getSector = useCallback(async () => {
        const response = await AxiosInstance.post('/data-input/sector-view', { user_login: localStorage.getItem('@gedy:user') });
        setOptionsSector(response.data);
    }, []);

    const getSubSector = useCallback(async (value) => {
        const data = { ...value, user_login: localStorage.getItem('@gedy:user') }
        const response = await AxiosInstance.post('/data-input/sub-sector-view', data);
        setOptionsSubSector(response.data);
    }, []);


    useEffect(() => {
        getDataTable({});
        getSector();
    }, [getDataTable, getSector]);

    return (
        <>
            <Box m={2}>
                {isDialogOpen() && (
                    <ViewDocumentDialog
                        key="unique-key-for-dialog"
                        handleClose={handleCloseDialog}
                        handleCancel={handleCancelAction}
                        dialogData={dialogData}
                    />
                )}
                <Grid container spacing={1}>
                    <Grid item xs={12} md={6} xl={6}>
                        <SelectAutoComplete
                            name='sector'
                            value={getFormData.sector}
                            options={getOptionsSector}
                            label='Selecione o Setor'
                            onChange={(event, selectValues) => handleChangeSector(event, selectValues)}
                            required={false}
                        />
                    </Grid>
                    <Grid item xs={12} md={6} xl={6}>
                        <SelectAutoComplete
                            name='sector'
                            value={getFormData.subSector}
                            options={getOptionsSubSector}
                            label='Selecione o Sub-Setor'
                            onChange={(event, selectValues) => handleChangeSubSector(event, selectValues)}
                            required={false}
                        />
                    </Grid>
                </Grid>
                <TableComponent
                    columns={columns}
                    rows={rows}
                />
            </Box>
        </>
    );
}

export default BodyViewDocument;